import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'

import { handleView } from '../redux/modules/signup/actions'
import ErrorResponse from '../components/Error/ErrorResponse'

export class SignupRetrieval extends React.Component {
  componentWillMount() {
    if (!this.props.errorResponse) {
      this.props.handleView(this.props.params.reference, this.props.location)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.errorResponse &&
      nextProps.params.reference !== this.props.params.reference
    ) {
      nextProps.handleView(nextProps.params.reference, nextProps.location)
    }
  }

  render() {
    if (this.props.errorResponse) {
      return <ErrorResponse response={this.props.errorResponse} />
    }

    return this.props.children
  }
}

SignupRetrieval.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  errorResponse: Pt.object,
  handleView: Pt.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: Pt.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  params: Pt.object.isRequired,
  children: Pt.node.isRequired,
}

const mapStateToProps = ({ signup }, { params }) => ({
  errorResponse: signup.getIn(['invalidResponses', params.reference]),
})

export default connect(mapStateToProps, { handleView })(SignupRetrieval)



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/SignupRetrieval.jsx